import Vue from 'vue';

const instanceList = {};

/**
 * Создание шины событий
 * Можно создавать множество уникальных экземпляров
 *
 * @param {string} instanceId - id экземпляра
 * @returns {CombinedVueInstance}
 * @constructor
 */
export default (instanceId = 'global') => {
  if (!(instanceId in instanceList)) {
    instanceList[instanceId] = new Vue();
  }

  return instanceList[instanceId];
};
